import HundredBricksAPIError from '@lib/hundredBricksAPI/HundredBricksAPIError';
class ActivateCouponError extends HundredBricksAPIError {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(...args) {
        super('ActivateCouponError', ...args);
    }
}
export default ActivateCouponError;
